import React, { useState, useCallback, useEffect } from "react";
import Map from "./components/map/map";
import { states, feetToMeter } from './constants/constants'
import { useNavigate, useLocation } from 'react-router-dom'
import { getDirectionFromPoint, getPointsFromDirection } from './services/mapbox/mapboxServices';
import Swal from 'sweetalert2';
import axios from 'axios';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { changeMetricUnit } from './services/redux/actions';
import { useGeolocated } from "react-geolocated";
import { format } from 'date-fns';

const feetSelector = createSelector(
    state => state.feets,
    feets => feets
);

function GarageEdit() {
    const navigate = useNavigate();
    const location = useLocation();
    const id = decodeURIComponent(location.pathname.split('/garage-edit/')[1]);
    const user = useSelector(state => state.user);
    const exceptThisSymbols = ["e", "E", "-", "+"]
    const profile_complete = useSelector(state => state.user.profile_complete);
    const userType = useSelector(state => state.user.userType);
    useEffect(() => {
        if (profile_complete != true) {
            navigate('/edit_user');
            Swal.fire({
                icon: 'info',
                title: 'Please complete your profile first.',
            });
        }
    }, [profile_complete]);

    useEffect(() => {
        if (userType != 'Owner') {
            navigate('/edit_user');
            Swal.fire({
                icon: 'info',
                title: 'A buyer don;t have permissions to add Garage.',
            });
        }
    }, [userType]);


    const feets = useSelector(feetSelector);
    const dispatch = useDispatch();

    function handleFeetConverterButton() {
        const reduxAction = changeMetricUnit(!feets);
        dispatch(reduxAction);
    }


    const elementOptions = states.map((item, index) => {
        return (
            <option value={item.value} key={index}> {item.info} </option>
        );
    });


    const [formClass, setFormClass] = useState(true);
    const [currentLocation, setCurrentLocation] = useState(null);
    const [inputFields, setInputFields] = useState({
        imageUrls: ""
    });


    const props = useGeolocated({
        positionOptions: {
            enableHighAccuracy: false
        },
        userDecisionTimeout: 5000
    })

    useEffect(() => {
        if (props.coords) {
            setCurrentLocation(() => ({
                longitude: props.coords.longitude,
                latitude: props.coords.latitude
            }));
        } else {
            //	actionForMap({ lng: defaultLongitude, lat: defaultLatitude });
        }
    }, [props.coords]);

const [existingImages, setExistingImages] = useState([]);
    const [previewImages, setPreviewImages] = useState([]);
    const [previewPDF, setPreviewPDF] = useState(null);
    const [previewPDFTwo, setPreviewPDFTwo] = useState(null);


    useEffect(() => {
        const data = axios.post(`${process.env.REACT_APP_API_URL}`, { action: 'GetGaragebyId', id: id })
            .then(response => {
                if (response.data.status === true) {
                    const data12 = response.data.data;

                    console.log('data12', data12)

                    if (user.uid !== data12.ownerID) {
                        alert('Permission Denied');
                        navigate('/garages')
                    }

                    const urlsArray = data12.garagePictures;
                    const garagePicturesAngle = data12.garagePicturesA;
                    let imagesURL = [];

                    if (urlsArray.length > 0) {
                        urlsArray.forEach((element, index) => {
                            const timestamp = format(new Date(), 'MMddyyyyHis');
                            const rotatedImage = {
                                src: process.env.REACT_APP_UPLOAD_URL + element + '?timestamp=' + timestamp,
                                rotation: garagePicturesAngle[index] ? garagePicturesAngle[index] : 0,
                            };
                            imagesURL = [...imagesURL, rotatedImage];
                        });
                    } else {
                        imagesURL = [{
                            url: './assets/Images/garage-placeholder.png',
                            rotation: 0, // Set a default rotation angle if needed
                        }];
                    }

                    setInputFields({
                        address: data12.address ? data12.address : '',
                        neighborhood: data12.neighborhood ? data12.neighborhood : '',
                        state: data12.state ? data12.state : '',
                        city: data12.city ? data12.city : '',
                        zipcode: data12.zipcode ? data12.zipcode : '',
                        latitude: data12.lat ? data12.lat : '',
                        longitude: data12.lon ? data12.lon : '',
                        length: data12.length ? data12.length : '',
                        width: data12.width ? data12.width : '',
                        mainDoorHeight: data12.mainDoorHeight ? data12.mainDoorHeight : '',
                        mainDoorWidth: data12.mainDoorWidth ? data12.mainDoorWidth : '',
                        isConnectedToHouse: data12.isConnectedToHouse == "true" ? true : false,
                        doorOpener: data12.doorOpener == "true" ? true : false,
                        drywalled: data12.drywalled == "true" ? true : false,
                        otherStorage: data12.otherStorage == "true" ? true : false,
                        sideDoor: data12.sideDoor == "true" ? true : false,
                        windows: data12.windows == "true" ? true : false,
                        electricalOutlets110V: data12.electricalOutlets110V == "true" ? true : false,
                        electricalOutlets220V: data12.electricalOutlets220V == "true" ? true : false,
                        heated: data12.heated == "true" ? true : false,
                        ac: data12.ac == "true" ? true : false,
                        description: data12.description ? data12.description : '',
                        rentalRate: data12.rentalRate ? data12.rentalRate : '',
                        deposit: data12.deposit ? data12.deposit : '',
                        lateCharge: data12.lateCharge ? data12.lateCharge : '',
                        bounceFee: data12.bounceFee ? data12.bounceFee : '',
                        garagePictures: '',
                        imageUrls: imagesURL,
                        garageInsurance: '',
                        garageSampleContract: '',
                    })
                    setPreviewPDF(data12.garageInsuranceURL ? process.env.REACT_APP_UPLOAD_URL + data12.garageInsuranceURL : '')
                    setPreviewPDFTwo(data12.sampleContractURL ? process.env.REACT_APP_UPLOAD_URL + data12.sampleContractURL : '')
                    setExistingImages(imagesURL)
                } else {
                    Swal.fire({
                        icon: 'info',
                        title: response.data.message,
                    });
                    navigate('/')
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });

    }, [id])


    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
        console.log(name, checked)
        setInputFields({
            ...inputFields,
            [name]: checked
        });
    };

    // const handleChange = (event) => {
    //     const { name, value } = event.target;
    //     setInputFields({
    //         ...inputFields,
    //         [name]: value
    //     });

    //     if (value.trim() !== '') {
    //         event.target.classList.remove('border-danger');
    //     }
    // };

    const handleChange = (event) => {
        const { name, value, type } = event.target;
        if (type == "number") {
            setInputFields({
                ...inputFields,
                [name]: event.target.value.slice(0, 20),
            });
        } else {
            setInputFields({
                ...inputFields,
                [name]: value,
            });
        }

        if (value.trim() !== "") {
            event.target.classList.remove("border-danger");
        }
    };

    const validateData = [
        {
            "inputName": "address",
            "displayName": "Address is required!"
        },
        {
            "inputName": "neighborhood",
            "displayName": "Neighborhood is required!"
        },
        {
            "inputName": "city",
            "displayName": "City is required!"
        },
        {
            "inputName": "state",
            "displayName": "State is required!"
        },
        {
            "inputName": "zipcode",
            "displayName": "Zipcode is required!"
        },
        {
            "inputName": "rentalRate",
            "displayName": "Rental Rate is required"
        },
        {
            "inputName": "garagePictures",
            "displayName": "Garage Picture is required"
        },
        {
            "inputName": "garageInsurance",
            "displayName": "Garage Insurance is required"
        },
        {
            "inputName": "garageSampleContract",
            "displayName": "Garage Sample Contract is required"
        },
    ]

    function findDisplayName(inputName) {
        const foundItem = validateData.find(item => item.inputName === inputName);
        return foundItem ? foundItem.displayName : null;
    }
    async function handleSubmit(event) {

        event.preventDefault();

        const requiredFields = ["rentalRate"];
        const isEmpty = requiredFields.some(field => !inputFields[field]);
        //  console.log('inputFields', inputFields);

        if (isEmpty) {

            const inputs = document.querySelectorAll('.AddressView .form-control');
            inputs.forEach(input => {
                input.classList.remove('border-danger');
                const fieldName = input.name;
                if (requiredFields.includes(fieldName) && input.value.trim() === '') {
                    input.classList.add('border-danger');
                    const existingErrorIcon = input.parentNode.querySelector('.text-danger');
                    if (!existingErrorIcon) {
                        const newErrorIcon = document.createElement('span');
                        newErrorIcon.classList.add('text-danger', 'la', 'la-exclamation-circle', 'error-icon');
                        input.parentNode.appendChild(newErrorIcon);

                        const tooltipText = document.createElement('span');
                        tooltipText.innerText = findDisplayName(input.name);
                        tooltipText.classList.add('badge', 'badge-danger', 'error-icon-text');
                        newErrorIcon.appendChild(tooltipText);

                        input.addEventListener('input', () => {
                            if (input.value.trim() !== '') {
                                const errorIcon = input.parentNode.querySelector('.text-danger');
                                if (errorIcon) {
                                    errorIcon.parentNode.removeChild(errorIcon);
                                }
                            }
                        });
                    }
                }
            });

            // Log error message
            console.log('Some required fields are empty!');
            return;
        }

        // Prevent submission if no existing images and no new uploaded images
if ((!existingImages || existingImages.length === 0) && (!inputFields.garagePictures || inputFields.garagePictures.length === 0)) {
    Swal.fire({
        icon: 'warning',
        title: 'At least one garage image is required!',
    });
    return;
}


        Swal.fire({
            title: 'Saving, please wait',
            html:
                '<div class="loadingio-spinner-rolling-w23e05eix9"><div class="ldio-ik6pzj2wupc"><div></div></div></div>',
            showConfirmButton: false,
            showCancelButton: false,
            focusConfirm: false,
        });
        const area = inputFields.width * inputFields.length
        if (!feets) {
            inputFields.width = feetToMeter(inputFields.width, false);
            inputFields.length = feetToMeter(inputFields.length, false);
            inputFields.mainDoorHeight = feetToMeter(inputFields.mainDoorHeight, false);
            inputFields.mainDoorWidth = feetToMeter(inputFields.mainDoorWidth, false);
        }
        //  console.log('inputFields',inputFields);
        //  return false;
        const formData = new FormData();
        formData.append('action', 'EditGarage');
        formData.append('id', id);
        formData.append('ownerID', user.uid);
        formData.append('ownerEmail', user.email);
        formData.append('address', inputFields.address);
        formData.append('city', inputFields.city);
        formData.append('state', inputFields.state);
        formData.append('zipcode', inputFields.zipcode);
        formData.append('length', inputFields.length);
        formData.append('width', inputFields.width);
        formData.append('mainDoorHeight', inputFields.mainDoorHeight);
        formData.append('mainDoorWidth', inputFields.mainDoorWidth);
        formData.append('isConnectedToHouse', inputFields.isConnectedToHouse);
        formData.append('doorOpener', inputFields.doorOpener);
        formData.append('drywalled', inputFields.drywalled);
        formData.append('otherStorage', inputFields.otherStorage);
        formData.append('sideDoor', inputFields.sideDoor);
        formData.append('windows', inputFields.windows);
        formData.append('electricalOutlets110V', inputFields.electricalOutlets110V);
        formData.append('electricalOutlets220V', inputFields.electricalOutlets220V);
        formData.append('heated', inputFields.heated);
        formData.append('ac', inputFields.ac);
        formData.append('description', inputFields.description);
        formData.append('rentalRate', inputFields.rentalRate);
        formData.append('deposit', inputFields.deposit);
        formData.append('lateCharge', inputFields.lateCharge);
        formData.append('bounceFee', inputFields.bounceFee);
        formData.append('area', area);
        formData.append('neighborhood', inputFields.neighborhood);
        formData.append('lat', inputFields.latitude);
        formData.append('lon', inputFields.longitude);
        //formData.append('garagePictures', garagePictures);
        for (let i = 0; i < inputFields.garagePictures.length; i++) {
            formData.append('garagePictures[]', inputFields.garagePictures[i]);
            formData.append('garagePicturesA[]', inputFields.garagePictures[i] && previewImages[i].rotation ? previewImages[i].rotation : 0);
        }
        formData.append('existingImages', JSON.stringify(existingImages));
        formData.append('garageInsuranceURL', inputFields.garageInsurance);
        formData.append('sampleContractURL', inputFields.garageSampleContract);

        axios.post(`${process.env.REACT_APP_API_URL}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
            .then(response => {
                // console.log(response.data.status);
                Swal.close();
                if (response.data.status === true) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Garage Updated',
                    }).then(() => {
                        navigate('/garages-details/'+id);
                    })
                } else {
                    Swal.fire(
                        'Oops...m',
                        `Something went wrong creating the garage <br><h3>${response.data.message}<h3>`,
                        'error'
                    );
                }
            })
            .catch(error => {
                Swal.close();
                Swal.fire(
                    'Oops...m',
                    `Something went wrong creating the garage ${error}`,
                    'error'
                );
            });

    };

    const mapAction = useCallback(async (newLngLt) => {
        try {
            const place = await getDirectionFromPoint(newLngLt);
            console.log('places', place);
            setCurrentLocation({ latitude: newLngLt['lat'], longitude: newLngLt['lng'] })

            setInputFields((prev) => {
                const newDirections = {};
                Object.keys(prev).forEach(key => {
                    const id = key;
                    if (place[id]) {
                        newDirections[id] = place[id];
                    } else {
                        newDirections[id] = prev[id];
                    }
                });

                return newDirections;
            });
        } catch (err) {
            throw err;
        }
    }, []);

    async function AcceptAddress(variable) {
        const requiredFields = ['address', 'neighborhood', 'city', 'state', 'zipcode'];
        const isEmpty = requiredFields.some(field => !inputFields[field]);
        if (isEmpty) {
            const inputs = document.querySelectorAll('.AddressEdit .form-control');
            inputs.forEach(input => {
                input.classList.remove('border-danger');
                if (input.value.trim() === '') {
                    input.classList.add('border-danger');
                    const existingErrorIcon = input.parentNode.querySelector('.text-danger');
                    if (!existingErrorIcon) {
                        const newErrorIcon = document.createElement('span');
                        newErrorIcon.classList.add('text-danger', 'la', 'la-exclamation-circle', 'error-icon');

                        input.parentNode.appendChild(newErrorIcon);

                        const tooltipText = document.createElement('span');
                        tooltipText.classList.add('badge', 'badge-danger', 'error-icon-text');
                        tooltipText.innerText = findDisplayName(input.name);
                        newErrorIcon.appendChild(tooltipText);

                        input.addEventListener('input', () => {
                            if (input.value.trim() !== '') {
                                const errorIcon = input.parentNode.querySelector('.text-danger');
                                if (errorIcon) {
                                    errorIcon.parentNode.removeChild(errorIcon);
                                }
                            }
                        });
                    }
                }
            });

            console.log('Some required fields are empty!');
            return;
        }

        try {
            const cors = await getPointsFromDirection({ address: inputFields.address, state: inputFields.state, city: inputFields.city, zipcode: inputFields.zipcode });
            setInputFields((prev) => {
                //  console.log("hello")
                const newDirections = {};
                Object.keys(prev).forEach(key => {
                    const id = key;
                    if (cors[id]) {
                        newDirections[id] = cors[id];
                    } else {
                        newDirections[id] = prev[id];
                    }
                });
                //  console.log('newDirections', newDirections);
                return newDirections;
            });
            setCurrentLocation({ latitude: cors.latitude, longitude: cors.longitude })
              console.log(cors, 'inputFields', inputFields);
              console.log("variable", variable)
            setFormClass(variable);
        } catch (error) {
            console.error('Error occurred:', error);
        }
    }


    // for Images
    const handleImagePreview = (event) => {
        const files = event.target.files;
        if (files) {
            const imageArray = [];
            for (let i = 0; i < files.length; i++) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    imageArray.push({ src: e.target.result, rotation: 0 });
                    if (imageArray.length === files.length) {
                        setPreviewImages(imageArray);
                    }
                };
                reader.readAsDataURL(files[i]);
            }
        }
        setInputFields({
            ...inputFields,
            garagePictures: files
        });
    };

    const openImageModal = (e) => {
        e.preventDefault();
        document.getElementById('imagePreviewModal').classList.add('show');
        document.getElementById('imagePreviewModal').style.display = 'block';
    };

    const closeModal = (event) => {
        event.preventDefault();
        // setPreviewImages([]);
        document.getElementById('imagePreviewModal').classList.remove('show');
        document.getElementById('imagePreviewModal').style.display = 'none';
    };

    const rotateImage = (index, event, type) => {
        event.preventDefault();
        if(type==='old'){
        setExistingImages(prevImages => {
            const updatedImages = [...prevImages];
            updatedImages[index].rotation = (updatedImages[index].rotation + 90) % 360;
            return updatedImages;
        });

        }else{            
        setPreviewImages(prevImages => {
            const updatedImages = [...prevImages];
            updatedImages[index].rotation = (updatedImages[index].rotation + 90) % 360;
            return updatedImages;
        });
        }
    };

    const removeImage = (index, event, type) => {
        event.preventDefault();
         if(type==='old'){
        setExistingImages(prevImages => {
            const updatedImages = [...prevImages];
            updatedImages.splice(index, 1);
            return updatedImages;
        });
         }else{
        setPreviewImages(prevImages => {
            const updatedImages = [...prevImages];
            updatedImages.splice(index, 1);
            return updatedImages;
        });

         }


        setInputFields(prevInputFields => {
            const updatedInputFields = { ...prevInputFields };
            const updatedGaragePictures = [...updatedInputFields.garagePictures];
            updatedGaragePictures.splice(index, 1);
            updatedInputFields.garagePictures = updatedGaragePictures;
            return updatedInputFields;
        });
    };

    // for pdf One
    const handlePDFPreview = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                setPreviewPDF(e.target.result);
            };
            reader.readAsDataURL(file);

            setInputFields({
                ...inputFields,
                garageInsurance: file
            });
        }

    };

    const removePdf = (event) => {
        setPreviewPDF(null);
        document.getElementById('pdfPreviewModal').style.display = 'none';
    }
    const openPDFModal = (event) => {
        event.preventDefault();
        document.getElementById('pdfPreviewModal').classList.add('show');
        document.getElementById('pdfPreviewModal').style.display = 'block';
    };

    const closePDFModal = (event) => {
        event.preventDefault();
        document.getElementById('pdfPreviewModal').classList.remove('show');
        document.getElementById('pdfPreviewModal').style.display = 'none';
    };

    // for pdf two
    const handlePDFTwoPreview = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                setPreviewPDFTwo(e.target.result);
            };
            reader.readAsDataURL(file);
            setInputFields({
                ...inputFields,
                garageSampleContract: file
            });
        }
    };

    const openPDFTwoModal = (event) => {
        event.preventDefault();
        document.getElementById('pdfPreviewModalTwo').classList.add('show');
        document.getElementById('pdfPreviewModalTwo').style.display = 'block';
    };

    const removePdfTwo = (event) => {
        setPreviewPDFTwo(null);
        document.getElementById('pdfPreviewModalTwo').style.display = 'none';

    }

    const closePDFTwoModal = () => {
        document.getElementById('pdfPreviewModalTwo').classList.remove('show');
        document.getElementById('pdfPreviewModalTwo').style.display = 'none';
    };



    return (
        <section className="page-content sec-padding half-map pt-0">
            <div className="container-full">
                <div className="page-content-details">
                    <div className="row">
                        <div className="col-xl-6 pl-0 ps-0 half-mpy">
                            <Map
                                type='position_selector'
                                action={mapAction}
                                elementStylePosition='fixed'
                                actionLabel="where_to_vote"
                                geoLocation={currentLocation}
                            />
                        </div>
                        <div className="col-xl-6 pl-0 ps-0 half-wd order--1">
                            <div className="widget-search-properties">
                                <div className="sec-title row justify-content-between">
                                    <h3>Edit Garage</h3>

                                </div>
                                {/* <form onSubmit={handleSubmit}> */}
                                <form className="form-gp">
                                    <div className={`AddressEdit ${formClass ? 'd-none' : ''}`}>
                                        <div className="form-group row">
                                            <label className="form-label col-md-4" htmlFor="address"> Address <span className="text-danger">*</span></label>
                                            <div className="col-md-8 d-flex position-relative">
                                                <input name="address" type="text"
                                                    className="form-control"
                                                    value={inputFields.address} onChange={handleChange} />
                                                {/* <p>I</p> */}

                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="form-label col-md-4" htmlFor="neighborhood"> Neighborhood <span className="text-danger">*</span></label>
                                            <div className="col-md-8 d-flex position-relative">
                                                <input name="neighborhood" type="text"
                                                    className="form-control"
                                                    value={inputFields.neighborhood} onChange={handleChange} />
                                                {/* <p>I</p> */}
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="form-label col-md-4" htmlFor="city"> City<span className="text-danger">*</span></label>
                                            <div className="col-md-8 d-flex position-relative">
                                                <input name="city" type="text"
                                                    className="form-control"
                                                    value={inputFields.city} onChange={handleChange} />
                                                {/* <p>I</p> */}
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="form-label col-md-4" htmlFor="state"> State<span className="text-danger">*</span></label>
                                            <div className="col-md-8 d-flex position-relative">
                                                <select name="state"
                                                    className="form-select"
                                                    value={inputFields.state} onChange={handleChange}>
                                                    <option value=""></option>
                                                    {elementOptions}
                                                </select>
                                                {/* <p>I</p> */}
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="form-label col-md-4" htmlFor="zipcode"> Zip Code<span className="text-danger">*</span></label>
                                            <div className="col-md-8 d-flex position-relative">
                                                <input name="zipcode" type="number"
                                                    className="form-control"
                                                    onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}

                                                    value={inputFields.zipcode} onChange={handleChange} />
                                                {/* <p>I</p> */}
                                            </div>

                                        </div>
                                        <input name="latitude" type="hidden" className="form-control" value={inputFields.latitude} readOnly />
                                        <input name="longitude" type="hidden" className="form-control" value={inputFields.longitude} readOnly />

                                        <button type="button" className="btn btn-primary btn-lg" onClick={() => AcceptAddress(true)}>Accept Address</button>
                                    </div>

                                    <div className={`AddressView ${formClass ? '' : 'd-none'} text-center p-5`}>
                                        <i type="button" className="fa fa-pencil text-primary" onClick={() => AcceptAddress(false)}></i>
                                        <p>Address : <b>{inputFields.address ? inputFields.address : ''}</b></p>
                                        <p>Neighborhood : <b>{inputFields.neighborhood ? inputFields.neighborhood : ''}</b></p>
                                        <p>City : <b>{inputFields.city ? inputFields.city : ''}</b></p>
                                        <p>State : <b>{inputFields.state ? inputFields.state : ''}</b></p>
                                        <p>Zip Code : <b>{inputFields.zipcode ? inputFields.zipcode : ''}</b></p>
                                    </div>
                                    <div className={`AddressView ${formClass ? '' : 'd-none'}`}>
                                        <div className="text-center">
                                            <h1>Complete your garage registration</h1>

                                            <button
                                                type="button"
                                                className="btn btn-primary  btn-lg my-3"
                                                onClick={handleFeetConverterButton}>{`Change to ${feets ? 'meter' : 'feet'}`}</button>


                                        </div>
                                        <h3>Garage Dimensions:</h3>
                                        <div className="form-group row">
                                            <label className="form-label col-md-4" htmlFor="length"> Length {feets ? 'ft' : 'm'}:</label>
                                            <div className="col-md-8 d-flex position-relative">
                                                <input name="length" type="number"
                                                    onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}

                                                    className="form-control" value={inputFields.length} onChange={handleChange} />
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <label className="form-label col-md-4" htmlFor="width"> Width {feets ? 'ft' : 'm'}:</label>
                                            <div className="col-md-8 d-flex position-relative">
                                                <input name="width" type="number"
                                                    onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}

                                                    className="form-control" value={inputFields.width} onChange={handleChange} />
                                            </div>
                                        </div>


                                        <div className="form-group row">
                                            <label className="form-label col-md-4" htmlFor="mainDoorHeight"> Main Door Height {feets ? 'ft' : 'm'}:</label>
                                            <div className="col-md-8 d-flex position-relative">
                                                <input name="mainDoorHeight" type="number"
                                                    onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}

                                                    className="form-control" value={inputFields.mainDoorHeight} onChange={handleChange} />
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <label className="form-label col-md-4" htmlFor="mainDoorWidth"> Main Door Width {feets ? 'ft' : 'm'}:</label>
                                            <div className="col-md-8 d-flex position-relative">
                                                <input name="mainDoorWidth" type="number"
                                                    onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}

                                                    className="form-control" value={inputFields.mainDoorWidth} onChange={handleChange} />
                                            </div>
                                        </div>
                                        <h3>Garage Features:</h3>
                                        <div className="form-group text-center mb-2">
                                            <input type="checkbox"
                                                className="btn-check" checked={inputFields.isConnectedToHouse}
                                                value={inputFields.isConnectedToHouse}
                                                name="isConnectedToHouse"
                                                id="isConnectedToHouse" onChange={handleCheckboxChange} />
                                            <label className="btn btn-outline-primary" htmlFor="isConnectedToHouse">Connected to the House</label><br />
                                        </div>
                                        <div className="form-group  text-center mb-2">
                                            <input type="checkbox" checked={inputFields.doorOpener}
                                                className="btn-check" name="doorOpener" id="doorOpener" onChange={handleCheckboxChange}
                                                value={inputFields.doorOpener}
                                            />
                                            <label className="btn btn-outline-primary" htmlFor="doorOpener">Door Opener</label><br />
                                        </div>
                                        <div className="form-group  text-center mb-2">
                                            <input type="checkbox" checked={inputFields.drywalled}
                                                className="btn-check" name="drywalled" id="drywalled" onChange={handleCheckboxChange}
                                                value={inputFields.drywalled}
                                            />
                                            <label className="btn btn-outline-primary" htmlFor="drywalled">Drywalled</label><br />
                                        </div>
                                        <div className="form-group  text-center mb-2">
                                            <input type="checkbox" checked={inputFields.otherStorage}
                                                className="btn-check" name="otherStorage" id="otherStorage" onChange={handleCheckboxChange}
                                                value={inputFields.otherStorage}
                                            />
                                            <label className="btn btn-outline-primary" htmlFor="otherStorage">Other Storage</label><br />
                                        </div>
                                        <div className="form-group  text-center mb-2">
                                            <input type="checkbox" checked={inputFields.sideDoor}
                                                className="btn-check" name="sideDoor" id="sideDoor" onChange={handleCheckboxChange}
                                                value={inputFields.sideDoor}
                                            />
                                            <label className="btn btn-outline-primary" htmlFor="sideDoor">Side Door</label><br />
                                        </div>
                                        <div className="form-group  text-center mb-2">
                                            <input type="checkbox" checked={inputFields.windows}
                                                className="btn-check" name="windows" id="windows" onChange={handleCheckboxChange}
                                                value={inputFields.windows}
                                            />
                                            <label className="btn btn-outline-primary" htmlFor="windows">Windows</label><br />
                                        </div>

                                        <div className="form-group row">
                                            <label className="form-label col-md-4"> 110V Electrical Outlets:</label>
                                            <div className="col-md-8">
                                                <input name="electricalOutlets110V" checked={inputFields.electricalOutlets110V}
                                                    id="electricalOutlets110V" type="checkbox"
                                                    value={inputFields.electricalOutlets110V}
                                                    className="form-check-input" onChange={handleCheckboxChange} />
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <label className="form-label col-md-4" > 220V Electrical Outlets:</label>
                                            <div className="col-md-8">
                                                <input name="electricalOutlets220V" checked={inputFields.electricalOutlets220V}
                                                    id="electricalOutlets220V" type="checkbox"
                                                    value={inputFields.electricalOutlets220V}
                                                    className="form-check-input" onChange={handleCheckboxChange} />
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <label className="form-label col-md-4"> Heated:</label>
                                            <div className="col-md-8 ">

                                                <div className="form-group">
                                                    <input
                                                        name="heated"
                                                        checked={inputFields.heated}
                                                        id="heated"
                                                        type="checkbox"
                                                        className="btn-check"
                                                        value={inputFields.heated}
                                                        onChange={handleCheckboxChange} />
                                                    <label className="btn btn-outline-primary me-3" htmlFor="heated">Heat</label>
                                                    {/* </div>
                                                <div className="form-group"> */}
                                                    <input name="ac" checked={inputFields.ac} id="ac" type="checkbox"
                                                        value={inputFields.ac}
                                                        className="btn-check" onChange={handleCheckboxChange} />
                                                    <label className="btn btn-outline-primary" htmlFor="ac">A/C</label>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <label className="form-label col-md-4" htmlFor="description"> Description:</label>
                                            <div className="col-md-8 d-flex position-relative">
                                                <textarea name="description" type="text"
                                                    className="form-control"
                                                    value={inputFields.description} onChange={handleChange} ></textarea>
                                            </div>
                                        </div>

                                        <h3>Garage Pricing</h3>
                                        <div className="form-group row">
                                            <label className="form-label col-md-4" htmlFor="rentalRate">Rental Rate <span className="text-danger">*</span></label>
                                            <div className="col-md-8 d-flex position-relative">
                                                <input name="rentalRate" type="number" className="form-control"
                                                    onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}

                                                    value={inputFields.rentalRate} onChange={handleChange} />
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <label className="form-label col-md-4" htmlFor="deposit">Deposit :</label>
                                            <div className="col-md-8 d-flex position-relative">
                                                <input name="deposit" type="number" className="form-control"
                                                    onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}

                                                    value={inputFields.deposit} onChange={handleChange} />
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <label className="form-label col-md-4" htmlFor="lateCharge">Late Charge:</label>
                                            <div className="col-md-8 d-flex position-relative">
                                                <input name="lateCharge" type="number" className="form-control"
                                                    onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}

                                                    value={inputFields.lateCharge} onChange={handleChange} />
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <label className="form-label col-md-4" htmlFor="bounceFee">Bounce Fee:</label>
                                            <div className="col-md-8 d-flex position-relative">
                                                <input name="bounceFee" type="number" className="form-control"
                                                    onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}

                                                    value={inputFields.bounceFee} onChange={handleChange} />
                                            </div>
                                        </div>

                                        <h3>Garage Files</h3>


                                        <div>
                                            <div className="form-group row" style={{ position: "relative" }}>
                                                <label className="form-label col-md-4" htmlFor="garagePictures">Garage Pictures <span className="text-danger">*</span></label>
                                                <div className="col-md-8 d-flex justify-content-between">
                                                    <input name="garagePictures" id="garagePictures" type="file" className="form-file form-control"
                                                        onChange={handleImagePreview} multiple />
                                                    <label htmlFor="garagePictures" className="btn btn-primary btn-lg">Choose Files</label>
                                                    {(previewImages.length > 0 || existingImages.length > 0) && <button className="btn btn-primary btn-lg" onClick={openImageModal}>File Preview</button>}
                                                </div>
                                            </div>

                                            {/* Modal for image preview */}
                                            {(previewImages.length > 0 || existingImages.length > 0) &&
                                                <div className="modal fade" id="imagePreviewModal" tabIndex="-1" role="dialog">
                                                    <div className="modal-dialog modal-lg" role="document">
                                                        <div className="modal-content">
                                                            <div className="modal-header">
                                                                <h5 className="modal-title">Image Preview</h5>
                                                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={closeModal}>
                                                                    <span aria-hidden="true"></span>
                                                                </button>
                                                            </div>
                                                            <div className="modal-body" style={{ maxHeight: "400px", overflowY: "auto" }}>
                                                                <div className="row">
                                                                    {existingImages.map((image, index) => (
                                                                        <div key={index} className="col-md-6 d-flex justify-content-center align-items-center mb-3">
                                                                            <div className="text-center">
                                                                                <img src={image.src} alt={`Preview ${index}`} style={{ transform: `rotate(${image.rotation}deg)`, width: "200px", height: "200px" }} className="img-fluid mb-2" />
                                                                                <div className="d-flex justify-content-around">
                                                                                    <i onClick={(event) => rotateImage(index, event,'old')} className="la la-refresh"></i>
                                                                                    <i onClick={(event) => removeImage(index, event,'old')} className="la la-trash"></i>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                    {previewImages.map((image, index) => (
                                                                        <div key={index} className="col-md-6 d-flex justify-content-center align-items-center mb-3">
                                                                            <div className="text-center">
                                                                                <img src={image.src} alt={`Preview ${index}`} style={{ transform: `rotate(${image.rotation}deg)`, width: "200px", height: "200px" }} className="img-fluid mb-2" />
                                                                                <div className="d-flex justify-content-around">
                                                                                    <i onClick={(event) => rotateImage(index, event,'new')} className="la la-refresh"></i>
                                                                                    <i onClick={(event) => removeImage(index, event,'new')} className="la la-trash"></i>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>

                                                            <div className="modal-footer">
                                                                <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={closeModal}>Close</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>

                                        <div>
                                            <div className="form-group row" style={{ position: "relative" }}>
                                                <label className="form-label col-md-4" htmlFor="garageInsurance">Garage Insurance <span className="text-danger">*</span></label>
                                                <div className="col-md-8 d-flex justify-content-between">
                                                    <input name="garageInsurance" id="garageInsurance" type="file" className="form-file form-control" accept=".pdf"
                                                        onChange={handlePDFPreview} />
                                                    <label htmlFor="garageInsurance" className="btn btn-primary btn-lg">Choose a File</label>
                                                    {previewPDF &&
                                                        <button className="btn btn-primary btn-lg" onClick={openPDFModal}>View Insurance</button>
                                                    }
                                                </div>
                                            </div>

                                            {/* Modal for PDF preview */}
                                            {previewPDF &&
                                                <div className="modal fade" id="pdfPreviewModal" tabIndex="-1" role="dialog">
                                                    <div className="modal-dialog modal-xxl" role="document">
                                                        <div className="modal-content">
                                                            <div className="modal-header">
                                                                <h5 className="modal-title">Garage Insurance Preview</h5>
                                                                <div><i onClick={(event) => removePdf(event)} className="la la-trash"></i></div>

                                                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={closePDFModal}>
                                                                    <span aria-hidden="true"></span>
                                                                </button>
                                                            </div>
                                                            <div className="modal-body">
                                                                <embed src={previewPDF} type="application/pdf" width="100%" height="500px" />
                                                            </div>
                                                            <div className="modal-footer">
                                                                <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={closePDFModal}>Close</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>

                                        <div>
                                            <div className="form-group row" style={{ position: "relative" }}>
                                                <label className="form-label col-md-4" htmlFor="garageSampleContract">Sample Contract <span className="text-danger">*</span></label>
                                                <div className="col-md-8 d-flex justify-content-between">
                                                    <input name="garageSampleContract" id="garageSampleContract" type="file" className="form-file form-control"
                                                        accept=".pdf" onChange={handlePDFTwoPreview} />
                                                    <label htmlFor="garageSampleContract" className="btn btn-primary btn-lg">Choose a File</label>
                                                    {previewPDFTwo &&
                                                        <button className="btn btn-primary btn-lg" onClick={openPDFTwoModal}>View Contract</button>
                                                    }
                                                </div>
                                            </div>

                                            {previewPDFTwo &&
                                                <div className="modal fade" id="pdfPreviewModalTwo" tabIndex="-1" role="dialog">
                                                    <div className="modal-dialog modal-xxl" role="document">
                                                        <div className="modal-content">
                                                            <div className="modal-header">
                                                                <h5 className="modal-title">Sample Contract Preview</h5>
                                                                <div><i onClick={(event) => removePdfTwo(event)} className="la la-trash"></i></div>

                                                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={closePDFTwoModal}>
                                                                    <span aria-hidden="true"></span>
                                                                </button>
                                                            </div>
                                                            <div className="modal-body">
                                                                <embed src={previewPDFTwo} type="application/pdf" width="100%" height="500px" />
                                                            </div>
                                                            <div className="modal-footer">
                                                                <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={closePDFTwoModal}>Close</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>

                                        <div className="form-group">
                                            <button type="submit" className="btn btn-primary btn-lg" onClick={handleSubmit} >Update Garage</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </section >
    )
}
export default GarageEdit;